<template>
  <div class="company_search">
    <job-header-simple header_title="服务企业" header_border="header_border"></job-header-simple>
    <van-search
      v-model="search_company_name"
      shape="round"
      background="#6c7ef3"
      @input="handleInput"
      placeholder="请填写公司名称"
    />
    <van-index-bar v-if="search_result_list.length == 0">
      <div v-for="(item,index) in listData" :key="'list'+index">
        <van-index-anchor :index="item.index" />
        <van-cell v-for="(item2,index2) in item.list" :key="'list2'+index2">
          <div class="item">
            <label>{{item2.abbreviation}}</label>
            <div class="info">
              <p class="title van-ellipsis">{{item2.ecompanyName}}</p>
              <p>
                <span>{{item2.employeeCount}}人</span>
                <span v-if="item2.cooperateRelax == 'documentary'">跟单佣金：{{item2.commissionRemark}}</span>
                <span v-if="item2.cooperateRelax == 'expand'">自拓佣金：{{item2.commissionRemark}}</span>
                <span v-if="item2.cooperateRelax == 'old'">老客户佣金：{{item2.commissionRemark}}</span>
              </p>
            </div>
          </div>
        </van-cell>
      </div>
    </van-index-bar>

    <van-cell v-for="(item,index) in search_result_list" :key="'search_list'+index" v-else>
      <div class="item">
        <label>{{item.label}}</label>
        <div class="info">
          <p class="title van-ellipsis">{{item.name}}</p>
          <p>
            <span>{{item.num}}人</span>
            <span>跟单佣金：跟单提成{{item.ratio}}%</span>
          </p>
        </div>
      </div>
    </van-cell>
  </div>
</template>

<script>
import { IndexBar, IndexAnchor, Cell, Search } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
export default {
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
    jobHeaderSimple
  },
  data() {
    return {
      search_company_name: "",
      search_result_list: [],
      listData: [
        {
          id: 1,
          index: "A",
          list: [
            {
              id: "1-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "1-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "1-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "1-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "1-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "1-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 2,
          index: "B",
          list: [
            {
              id: "2-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "2-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "2-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "2-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "2-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "2-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 3,
          index: "D",
          list: [
            {
              id: "3-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "3-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "3-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "3-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "3-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "3-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 4,
          index: "E",
          list: [
            {
              id: "4-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "4-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "4-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "4-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "4-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "4-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 5,
          index: "G",
          list: [
            {
              id: "5-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "5-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "5-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "5-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "5-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "5-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 6,
          index: "K",
          list: [
            {
              id: "6-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "6-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "6-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "6-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "6-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "6-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        },
        {
          id: 7,
          index: "V",
          list: [
            {
              id: "7-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "7-002",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "7-003",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "7-004",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "7-005",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            },
            {
              id: "7-001",
              label: "远行科技",
              name: "深圳市远行科技股份有限公司",
              num: 112,
              ratio: 1
            }
          ]
        }
      ],
      all_company_list: []
    };
  },
  created() {
    this.listData.forEach(item => {
      item.list.forEach(item2 => {
        this.all_company_list.push(item2);
      });
    });
    this.getCompanyByName();
  },
  methods: {
    handleInput() {
      // this.search_result_list.length = 0;
      // if (this.search_company_name.length) {
      // this.all_company_list.forEach(item => {
      //   if (item.name.indexOf(this.search_company_name) > -1) {
      //     this.search_result_list.push(item);
      //   }
      // });

      // }
      this.getCompanyByName();
    },
    getCompanyByName() {
      api.getCompanyByName({ name: this.search_company_name }).then(res => {
        this.listData = res.data.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.company_search {
  /deep/ .van-index-anchor--sticky {
    color: #6c7ef3;
  }

  /deep/ .van-index-bar__index--active {
    color: #6c7ef3;
  }
  .item {
    label {
      display: inline-block;
      vertical-align: middle;
      width: 1.2rem;
      height: 1.2rem;
      background: #b6c0ff;
      border-radius: 100%;
      text-align: center;
      padding: 0.2rem 0.08rem;
      line-height: 0.4rem;
      box-sizing: border-box;
      font-size: 0.36rem;
      color: #fff;
    }

    .info {
      display: inline-block;
      vertical-align: middle;
      max-width: 80%;
      margin-left: 0.2667rem;

      p {
        color: #999;
        &:first-child {
          font-size: 0.42rem;
          color: #333;
        }

        span + span {
          margin-left: 0.3rem;
        }
      }
    }
  }
}
</style>